import React from 'react'
import { Link } from 'gatsby'

// Utilities
import kebabCase from 'lodash/kebabCase'
import primaryColor from '../../utils/primaryColor'

class EventsNav extends React.Component {
  render() {
    let items = this.props.items
    var first = 'Core Programming'
    items.sort(
      (x, y) => (x.fieldValue === first ? -1 : y.fieldValue === first ? 1 : 0)
    )
    //let currentItem = this.props.currentItem

    return (
      <ul className="subnav events-subnav">
        <li>
          <Link activeStyle={{ color: primaryColor() }} to="/programs/">
            ALL
          </Link>
        </li>

        {items.map(node => (
          <li key={node.fieldValue}>
            <Link
              activeStyle={{ color: primaryColor() }}
              to={`/${kebabCase(node.fieldValue)}/`}
            >
              {node.fieldValue}
            </Link>
          </li>
        ))}
      </ul>
    )
  }
}

export default EventsNav
